import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'French', flag: '🇫🇷' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (languageCode) => {
    i18n?.changeLanguage(languageCode);
    setIsOpen(false);
  };

  const currentLanguage = languages?.find(lang => lang?.code === i18n?.language) || languages?.[0];

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-muted hover:bg-muted/80 rounded-lg transition-colors"
        aria-label="Select Language"
      >
        <span className="text-lg">{currentLanguage?.flag}</span>
        <span className="hidden sm:inline text-sm font-medium text-foreground">
          {currentLanguage?.name}
        </span>
        <Icon name="ChevronDown" size={16} color="var(--color-foreground)" />
      </button>
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-card border border-border rounded-lg shadow-lg py-2 z-50">
          {languages?.map((language) => (
            <button
              key={language?.code}
              onClick={() => handleLanguageChange(language?.code)}
              className={`w-full flex items-center gap-3 px-4 py-2 text-sm hover:bg-muted transition-colors ${
                i18n?.language === language?.code ? 'bg-muted' : ''
              }`}
            >
              <span className="text-lg">{language?.flag}</span>
              <span className="text-foreground font-medium">{language?.name}</span>
              {i18n?.language === language?.code && (
                <Icon name="Check" size={16} color="var(--color-primary)" className="ml-auto" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;